var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 14.8749L11.7987 11.7986M11.7987 11.7986C12.3249 11.2724 12.7424 10.6477 13.0271 9.96016C13.3119 9.27263 13.4585 8.53574 13.4585 7.79157C13.4585 7.04739 13.3119 6.3105 13.0271 5.62297C12.7424 4.93544 12.3249 4.31074 11.7987 3.78453C11.2725 3.25831 10.6478 2.8409 9.96029 2.55612C9.27276 2.27133 8.53587 2.12476 7.79169 2.12476C7.04751 2.12476 6.31062 2.27133 5.6231 2.55612C4.93557 2.8409 4.31086 3.25831 3.78465 3.78453C2.72192 4.84726 2.12488 6.28864 2.12488 7.79157C2.12488 9.2945 2.72192 10.7359 3.78465 11.7986C4.84738 12.8613 6.28876 13.4584 7.79169 13.4584C9.29462 13.4584 10.736 12.8613 11.7987 11.7986Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1885660a9089d41a4e1dc8e819219f5e.svg";
export { ForwardRef as ReactComponent };